(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("globalBundle", [], factory);
	else if(typeof exports === 'object')
		exports["globalBundle"] = factory();
	else
		root["globalBundle"] = factory();
})(this, function() {
return 